import { render, staticRenderFns } from "./parlayGenerator.vue?vue&type=template&id=5f840504&lang=pug&"
import script from "./parlayGenerator.vue?vue&type=script&lang=js&"
export * from "./parlayGenerator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports